import React, {useContext} from "react"
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import {useChildModuleContext} from "root/Wieldy/ApplicationModules/Child/ChildModuleContext";
import {ModalCommunicationPlanModes} from "root/Modals/CommunicationPlan/ModalCommunicationPlan";

const ChildCommunicationsPlanSubmenu = (props ) =>
{
    const { showCommPlanModal } = useChildModuleContext() ;

    const onClickAddCommunicationsPlan = () =>
    {
        showCommPlanModal ( {mode: ModalCommunicationPlanModes.CREATE, child_uid: props.child_uid } ) ;
    }

    return (
        <WieldySidebarSection title='New User' >
            <WieldySidebarClick modal={(event) => onClickAddCommunicationsPlan(event)} title='New Plan' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>
        </WieldySidebarSection>
    )
}

export default ChildCommunicationsPlanSubmenu ;